import { OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GLOBAL } from 'src/app/services/global';
var AuxUrlInspeccionComponent = /** @class */ (function () {
    function AuxUrlInspeccionComponent(dialog, _router) {
        this.dialog = dialog;
        this._router = _router;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
        this.filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
        this.seguimientoCertificados = GLOBAL.seguimientoCertificados;
    }
    AuxUrlInspeccionComponent.prototype.ngOnInit = function () {
    };
    AuxUrlInspeccionComponent.prototype.abrirInspeccion = function () {
        console.log('===ABRIR INGRESO ====');
        this._router.navigate(['/inspeccion']);
        this.dialog.closeAll();
    };
    return AuxUrlInspeccionComponent;
}());
export { AuxUrlInspeccionComponent };
